<div class="blog-wrapper">
  <div class="blog-hero">
    <h1 class="blog-title">{{'BLOG.HERO_TITLE' | translate }}</h1>
    <p class="blog-subtitle">
      {{'BLOG.HERO_SUBTITLE' | translate }}    </p>
  </div>

  <div class="blog-list">
    <article *ngFor="let post of posts" class="blog-card">
      <a [routerLink]="['/blog', post.slug]" class="card-link">
        <h2 class="card-title">{{ post.title }}</h2>
        <p class="card-description">{{ post.description }}</p>
        <span class="card-readmore">➡ Beitrag lesen</span>
      </a>
    </article>
  </div>
</div>
